import type { IndexRecord } from "../../shared/snapshot-format";
import { DATA_ROOT, fetchJson, loadManifest } from "./manifest";

let cached: Promise<IndexRecord[]> | undefined;

/** The prebuilt catalogue across every shipped Pack. Loaded once and kept in memory. */
export function loadCatalogue(): Promise<IndexRecord[]> {
  cached ??= loadManifest().then((m) => fetchJson<IndexRecord[]>(`${DATA_ROOT}/${m.index.path}`));
  return cached;
}

export interface CatalogueQuery {
  text: string;
  /** Include Legacy (non-Remaster) Entries. Off by default (docs/design.md). */
  legacy: boolean;
  limit: number;
}

/**
 * Case-insensitive name search: prefix matches first, then substring matches, each group in
 * name order. A full-text index is a later concern (issue: Pack browser and search).
 */
export function searchCatalogue(records: IndexRecord[], q: CatalogueQuery): IndexRecord[] {
  const needle = q.text.trim().toLowerCase();
  if (!needle) return [];
  const prefix: IndexRecord[] = [];
  const contains: IndexRecord[] = [];
  for (const r of records) {
    if (!q.legacy && !r.rm) continue;
    const name = r.n.toLowerCase();
    if (name.startsWith(needle)) prefix.push(r);
    else if (name.includes(needle)) contains.push(r);
  }
  const byName = (a: IndexRecord, b: IndexRecord): number => a.n.localeCompare(b.n);
  return [...prefix.sort(byName), ...contains.sort(byName)].slice(0, q.limit);
}
